var map = {
	"./module-1-check-in.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-1-check-in.svg",
	"./module-1-facts.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-1-facts.svg",
	"./module-1-plan.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-1-plan.svg",
	"./module-1-ready.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-1-ready.svg",
	"./module-1-summary.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-1-summary.svg",
	"./module-1-team.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-1-team.svg",
	"./module-2-check-in.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-2-check-in.svg",
	"./module-2-coping.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-2-coping.svg",
	"./module-2-plan.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-2-plan.svg",
	"./module-2-summary.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-2-summary.svg",
	"./module-2-triggers.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-2-triggers.svg",
	"./module-2-withdrawal.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-2-withdrawal.svg",
	"./module-3-check-in.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-3-check-in.svg",
	"./module-3-plan.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-3-plan.svg",
	"./module-3-refusal.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-3-refusal.svg",
	"./module-3-summary.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-3-summary.svg",
	"./module-4-check-in.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-4-check-in.svg",
	"./module-4-plan.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-4-plan.svg",
	"./module-4-stress.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-4-stress.svg",
	"./module-4-summary.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-4-summary.svg",
	"./module-5-check-in.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-5-check-in.svg",
	"./module-5-moods.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-5-moods.svg",
	"./module-5-plan.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-5-plan.svg",
	"./module-5-summary.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-5-summary.svg",
	"./module-6-check-in.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-6-check-in.svg",
	"./module-6-decision-1.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-6-decision-1.svg",
	"./module-6-decision-2.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-6-decision-2.svg",
	"./module-6-plan.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-6-plan.svg",
	"./module-6-summary.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-6-summary.svg",
	"./module-7-check-in.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-7-check-in.svg",
	"./module-7-future.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-7-future.svg",
	"./module-7-plan.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-7-plan.svg",
	"./module-7-summary.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/session/module-7-summary.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/svg/session sync recursive !!./node_modules/html-loader/dist/cjs.js! ^\\.\\/.*\\.svg$";